export class GoogleWorkspaceOrgUnit {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "orgUnitId",
            "baseName": "orgUnitId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgUnitPath",
            "baseName": "orgUnitPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "parentOrgUnitId",
            "baseName": "parentOrgUnitId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceOrgUnit.attributeTypeMap;
    }
    constructor() {
    }
}
